import { render } from "./ArchiveView.vue?vue&type=template&id=4109d2d1&scoped=true"
import script from "./ArchiveView.vue?vue&type=script&lang=js"
export * from "./ArchiveView.vue?vue&type=script&lang=js"

import "./ArchiveView.vue?vue&type=style&index=0&id=4109d2d1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4109d2d1"

export default script